import React from 'react'

export default function PageNotFound() {
  return (
    <div>
        <h1>status code 404 page not found</h1>
    </div>
  )
}
